const SeperatorMenuLine = () => {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width='288'
			height='2'
			viewBox='0 0 288 2'
			fill='none'>
			<line
				x1='-8.74228e-08'
				y1='1'
				x2='288'
				y2='0.999975'
				stroke='url(#paint0_linear_118_211)'
				strokeWidth='2'
			/>
			<defs>
				<linearGradient
					id='paint0_linear_118_211'
					x1='4.37114e-08'
					y1='2.5'
					x2='288'
					y2='2.49997'
					gradientUnits='userSpaceOnUse'>
					<stop stopColor='white' />
					<stop
						offset='0.5'
						stopColor='#CFB6DD'
					/>
					<stop
						offset='1'
						stopColor='white'
					/>
				</linearGradient>
			</defs>
		</svg>
	);
};

export default SeperatorMenuLine;
